<template>
  <section :class="['contain','theme_'+common.theme]">
    <template  v-if="$store.state.common.theme!=3">
      <section class="tips" v-if="home.noticeList.length" @click="toNotice()">
        <span class="tips_t">公告</span>
        <swiper class="swiper swiper-no-swiping" :options="options">
          <swiper-slide v-for="(item,index) in home.noticeList" :key="index" @click="toNotice()">
            <p @click="toNotice()">{{item.noticeTitle}}</p>
            <img src="../../../assets/images/icon_indicator_next.png" />
          </swiper-slide>
        </swiper>
      </section>
      <div v-if="couponArr &&isShowcoupon &&couponArr.length>0" class="xiangmudiv">
        <img @click="toprojectIntro" class="xiangmuImg" :src="require(`../../../assets/images/themes/img_banner_project1_${common.theme}.jpg`)" />
        <img @click="tolingquan" class="lingquanImg" :src="require(`../../../assets/images/img_banner_project_lingquan.jpg`)" />
      </div>
      <router-link v-else-if="isShowcoupon"  tag="section" class="intro" to="/projectIntro">
        <img :src="require(`../../../assets/images/themes/img_banner_project_${common.theme}.jpg`)" />
        <p>点击查看{{common.marketInfo.marketName}}项目介绍</p>
      </router-link>
    </template>
    <template  v-if="$store.state.common.theme==3">
      <section class="tips_3" v-if="home.noticeList.length" @click="toNotice()">
        <!-- <span class="tips_t">公告</span> -->
        <swiper class="swiper swiper-no-swiping" :options="options">
          <swiper-slide v-for="(item,index) in home.noticeList" :key="index" @click="toNotice()">
            <img src="../../../assets/images/icon_index_notices.png" /> 
            <p @click="toNotice()">{{item.noticeTitle}}</p>
            <!---->
          </swiper-slide>
        </swiper>
      </section>
    </template>
  </section>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: "indexTips",
  props: {
    couponArr: {
      type: Array,
      default() {
        return [];
      }
    },
    isShowcoupon:{
      type:Boolean,
      default(){
        return false;
      }
    }
  },
  data() {
    return {
      list:[],
      options: {
        direction:'vertical',
        observeParents: true,
        autoplay: 4000,
        speed: 1000,
        loop: true,
        observer: true,
      }
    };
  },
  computed: {
    ...mapState({
      common: state => state.common,
      home: state => state.home
    })
  },
  created() {

  },

  methods: {
    toNotice(){
      this.$router.push(`/noticeList`);
    },
    toprojectIntro(){
      this.$router.push(`/projectIntro`);
    },
    tolingquan(){
      this.$router.push(`/distributionVoucher`);
    }

  }
};
</script>
<!-- background-color:radial-gradient(circle, #d6bf9f 0%, #fff4e3 100%);  -->
 <!--  background:linear-gradient(270deg, #d6bf9f 0%, #fff4e3 100%); -->
   <!--  background: #fff; -->
<style lang="less" scoped>

@import "../../../assets/css/common.less";
.contain {
  padding: 0 0.2rem;
 
  .tips {
    height: 1rem;
    .flex();
    align-items: center;
    border-top: 0.015rem solid #eaeaea;
    border-bottom: 0.015rem solid #eaeaea;
    margin-bottom: 0.4rem;
    margin-left:8px;
    margin-right:8px;
    .tips_t {
      width: 0.6rem;
      border-radius: 0.04rem;
      border: 0.02rem solid @color17;
      height: 0.32rem;
      text-align: center;
      line-height: 0.32rem;
      box-sizing: border-box;
      color: @color17;
      display: block;
      margin-right: 0.2rem;
      flex-shrink: 0;
      font-size: 0.22rem;
    }
    .swiper{
      flex:1;
      height:1rem;
      overflow:hidden;
      .swiper-wrapper {
        width: 100% !important;
        height: 100% !important;
        position: relative;
      }
      .swiper-slide {
        width: 100% !important;
        height: 100% !important;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
      }
    }
    p {
      flex: 1;
      white-space: nowrap;
      height:32px;
      font-size:28px;
      color:rgba(51,51,51,1);
      line-height:34px;
      .textOver(100%);
    }
    img{
      width:36px;
      height:36px;
      display:block;
    }
  }
  .tips_3 {

    height: 0.5rem;
    .flex();
    align-items: center;
    border-radius: 0.25rem;
   
    background: radial-gradient(circle at center , #d6bf9f 0%, #fff4e3 100%);
    margin-top:0.4rem;
    margin-bottom: 0.4rem;
    margin-left:8px;
    margin-right:8px;
    .tips_t {
      width: 0.6rem;
      border-radius: 0.04rem;
      border: 0.02rem solid @color17;
      height: 0.32rem;
      text-align: center;
      line-height: 0.32rem;
      box-sizing: border-box;
      color: @color17;
      display: block;
      margin-right: 0.2rem;
      flex-shrink: 0;
      font-size: 0.22rem;
    }
    .swiper{
      flex:1;
      height:0.5rem;
      overflow:hidden;
      .swiper-wrapper {
        width: 100% !important;
        height: 100% !important;
        position: relative;
      }
      .swiper-slide {
        width: 100% !important;
        height: 100% !important;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
      }
    }
    p {
      margin-left: 20px;
      flex: 1;
      white-space: nowrap;
      height:32px;
      font-size:24px;
      color:rgba(51,51,51,1);
      line-height:32px;
      .textOver(100%);
    }
    img{
      margin-left: 20px;
      width:32px;
      height:32px;
      display:block;
    }
  }
  .intro {
    width: 100%;
    height: 1.4rem;
    border-radius:8px;
    position: relative;
    overflow: hidden;
    img{
      display:block;
      width:100%;
      height: 1.4rem;
    }
    p {
      position: absolute;
      height: 0.34rem;
      font-size: 0.24rem;
      color: rgba(153, 153, 153, 1);
      line-height: 0.34rem;
      top: 0.82rem;
      left: 0.28rem;
    }
  }
  .xiangmudiv{
    width: 100%;
    height: 180px;
    flex-direction: row;
    justify-content: space-between;
    display: flex;
    .xiangmuImg{
      width: 344px;
      height: 180px;
    }
    .lingquanImg{
      width: 344px;
      height: 180px;
    }

  }
}

</style>
